import {useState} from "react";
import useTranslations from "@/hooks/useTranslations";

type PricingFaqsProps = {
    minimumPurchase: number;
    freeHours: number;
}

export default function PricingFaqs(props: PricingFaqsProps) {
    const { __ } = useTranslations();
    const [openFaqs, setOpenFaqs] = useState<Set<number>>(new Set());

    const faqEntries = __('pricing.faqs.entries');

    const toggleFaq = (index: number) => {
        setOpenFaqs(prev => {
            const newSet = new Set(prev);
            if (newSet.has(index)) {
                newSet.delete(index);
            } else {
                newSet.add(index);
            }
            return newSet;
        });
    };

    // Fallback in case translations aren't loaded or are in wrong format
    const entries = Array.isArray(faqEntries) ? faqEntries : [];

    return (
        <section className="py-12">
            <div className="max-w-4xl mx-auto">
                <h2 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-8 text-center">
                    {__('pricing.faqs.title')}
                </h2>
                <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden">
                    {entries.map((faq: any, index: number) => (
                        <div key={index} className={index !== entries.length - 1 ? "border-b border-gray-200 dark:border-gray-700" : ""}>
                            <button
                                onClick={() => toggleFaq(index)}
                                className="w-full px-6 py-5 text-left flex justify-between items-center hover:bg-gray-50 dark:hover:bg-gray-700 focus:outline-none focus:bg-gray-50 dark:focus:bg-gray-700 transition-colors duration-150"
                            >
                                <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100 pr-4">
                                    {faq.question}
                                </h3>
                                <div className="flex-shrink-0">
                                    {openFaqs.has(index) ? (
                                        <svg className="w-5 h-5 text-gray-400 dark:text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M20 12H4" />
                                        </svg>
                                    ) : (
                                        <svg className="w-5 h-5 text-gray-400 dark:text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 4v16m8-8H4" />
                                        </svg>
                                    )}
                                </div>
                            </button>
                            <div
                                className={`overflow-hidden transition-all duration-300 ease-in-out ${
                                    openFaqs.has(index) ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                                }`}
                            >
                                <div className="px-6 pb-5 pt-2">
                                    <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
                                        {faq.answer
                                            .replace(':minimum_purchase', props.minimumPurchase.toString())
                                            .replace(':free_hours', props.freeHours.toString())}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}
